<template lang="pug">
.list-search
  el-form(:model="searchData" inline)
    el-form-item(label="商品名称:")
      el-input(placeholder="请输入商品品名 材质 规格 钢厂" v-model.trim="searchData.title" size="small")
    el-form-item(label="商品编号:")
      el-input(placeholder="请输入商品编号" v-model.trim="searchData.itemId" size="small")
    el-form-item(label="仓库:")
      el-autocomplete.w-300(placeholder="请输入仓库" v-model="warehouseName" size="small"
        @select="handleSelect" :fetch-suggestions="getWarehosesList" @blur="warehosesBlur")
        template(slot-scope="{ item }")
          span {{item.nameAbbr}}
    el-form-item(label="供应商:")
      el-input(placeholder="请输入供应商" v-model.trim="searchData.supplierName" size="small")
    el-form-item(label="创建人手机号:")
      el-input(placeholder="请输入创建人手机号" v-model.trim="searchData.createUserPhone" size="small")
    el-form-item(label="更新人手机号:")
      el-input(placeholder="请输入更新人手机号" v-model.trim="searchData.operateUserPhone" size="small")
    el-form-item(label="二级类目名：")
      el-select(v-model="searchData.secondCategoryId" placeholder="选择二级类目名" size="small")
        el-option(label="全部" value="")
        el-option(v-for="item, index in goodsCategories" :key="index" :label="item.name" :value="item.id")
    el-form-item(label="地区：")
      el-select.mini(v-model="searchData.provinceCode" placeholder="选择省份" size="small" @change="getCities")
        el-option(label="全部" value="")
        el-option(v-for="item, index in provinces" :key="index" :label="item.provinceName" :value="item.provinceCode")
      el-select.mini(v-model="searchData.cityCode" placeholder="选择城市" size="small")
        el-option(label="全部" value="")
        el-option(v-for="item, index in cities" :key="index" :label="item.cityName" :value="item.cityCode")
    //- el-form-item(v-if="getIsShowFreightTemplate" label="运费模版：")
    //-   el-select.mini(v-if="freightTemplateList.length > 0" v-model="searchData.transportTemplateId" placeholder="选择运费模版" size="small")
    //-     el-option(label="请选择" :value="0")
    //-     el-option(v-for="ft in freightTemplateList" :label="ft.templateName"
    //-       :value="ft.id" :key="ft.id")
    el-form-item
      el-button(type="primary" @click="onSearch()" size="small")  查询
    el-form-item(v-if="showExport")
      el-button(@click="onExport()" type="primary" size="small") 导出
    el-form-item
      el-button(@click="resetSearchData" size="small") 重置
    el-form-item
      batch-export(@loopSuccess="onSearch()")
    el-form-item
      el-button.bgc-f(type="danger" plain @click="$router.push('/goods/create/normal')" size="small")  手动录入商品
    el-form-item
      el-button.bgc-f(type="danger" plain @click="$router.push('/goods/create/indefinite')" size="small")  录入不定规格商品
    el-form-item
      el-button.bgc-f(type="danger" plain size="small" @click="$router.push('/goods/exportRecord')")  查看导入记录
</template>

<script>
import batchExport from './batchExportGoods.vue'

export default {
  name: 'ListSearch',
  props: {
    showExport: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchData: {
        title: '',
        itemId: '',
        secondCategoryId: '',
        warehouseId: '',
        provinceCode: '',
        cityCode: '',
        supplierName: '',
        createUserPhone: '',
        operateUserPhone: '',
        transportTemplateId: 0
      },
      warehouseName: '',
      goodsCategories: [],
      provinces: [],
      cities: []
      // freightTemplateList: [] // 运费模版 list
    }
  },
  components: {
    batchExport
  },
  // computed: {
  //   // 是否显示运费模版
  //   getIsShowFreightTemplate() {
  //     return this.freightTemplateList.length > 0 && this.freightTemplateList.some(ft => ft.id === this.searchData.transportTemplateId)
  //   }
  // },
  mounted() {
    this.getCategoryTree()
    this.getProvinces()
    // this.getLgFreightTemplateList()
  },
  methods: {
    /** 重置查询条件 */
    resetSearchData() {
      this.searchData.title = ''
      this.searchData.itemId = ''
      this.searchData.secondCategoryId = ''
      this.searchData.warehouseId = ''
      this.searchData.cityCode = ''
      this.searchData.provinceCode = ''
      this.searchData.createUserPhone = ''
      this.searchData.operateUserPhone = ''
      this.searchData.supplierName = ''
      this.cities = []
      this.warehouseName = ''
      this.warehouseNameCoyp = ''
      this.searchData.status = '1'
      // this.searchData.transportTemplateId = 0 // 和模版关联的商品
      this.onSearch()
    },
    /** 获取商品列表 */
    onSearch(data = {}) {
      this.$emit('onSearch', Object.assign(data, this.searchData))
    },
    onExport(data = {}) {
      this.$emit('onExport', Object.assign(data, this.searchData))
    },
    /** 选择仓库 */
    handleSelect(item) {
      this.warehouseName = item.nameAbbr
      this.warehouseNameCoyp = item.nameAbbr
      this.searchData.warehouseId = item.id
    },
    /** 查询仓库失去焦点 */
    warehosesBlur() {
      if (!this.searchData.warehouseId || !this.warehouseName) {
        this.warehouseName = ''
        this.warehouseNameCoyp = ''
        this.searchData.warehouseId = ''
      }
    },
    /** 仓库模糊查询 */
    async getWarehosesList(name, cb) {
      let searchList = []
      if (name) {
        if (this.warehouseNameCoyp !== name) {
          this.searchData.warehouseId = ''
        }
        try {
          const result = await this.$post(
            'wh.pageQueryWarehoses',
            {
              warehoseQuery: {
                name,
                pageNo: 1,
                pageSize: 1000
              }
            },
            { notNeedLoading: true }
          )
          if (result.success && result.data[0]) {
            searchList = result.data[0].warehoses || [{ nameAbbr: '暂无数据' }]
          } else {
            searchList = [{ nameAbbr: '暂无数据' }]
          }
          cb(searchList)
        } catch (err) {
          console.log(err)
        }
      } else {
        cb([{ nameAbbr: '暂无数据' }])
      }
    },
    /** 获取类目列表*/
    async getCategoryTree(id) {
      try {
        const result = await this.$post('items.getCategory', {
          level: 2,
          type: 1
        })
        if (result.success) {
          this.goodsCategories = result.data[0].value
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 获取省 */
    async getProvinces() {
      try {
        const result = await this.$post('user.getProvinces', {
          provinceCode: ''
        })
        if (result.success) {
          this.provinces = result.data[0].value || []
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 获取市 */
    async getCities() {
      this.searchData.cityCode = ''
      try {
        const result = await this.$post('user.getCities', {
          fatherCode: this.searchData.provinceCode
        })
        if (result.success) {
          this.cities = result.data[0].value || []
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.list-search
  .bgc-f
    background #fff
    background-color #fff
    &:focus
      color #ff4949
    &:hover
      color #fff
      background-color #ff4949

  .mini
    width 120px
</style>
